<template>
  <div>
    <serveur-info :erreur="error" />
    <form @submit.prevent="validateBeforeSubmit">
      <my-notification :icon="ICON">
        <template #title>
          {{ $t('compAdminEntityCampus.title-1') }}
        </template>
        {{ $t('compAdminEntityCampus.info-1') }}
      </my-notification>
      <br />
      <entity-form v-model="campus" @input="inputChanged" />
      <b-notification :closable="false">
        <type-input v-model="campus.type" />
      </b-notification>
      <b-notification :closable="false">
        <domain-input v-model="campus.domains" />
      </b-notification>
      <br />
      <nav class="level">
        <div class="level-left"></div>
        <div class="buttons level-right">
          <b-button
            class="button"
            @click="initCampus"
            :disabled="resetDisabled"
            icon-left="close"
          >
            {{ $t('cancel') }}
          </b-button>
          <button
            type="submit"
            :disabled="saveDisabled"
            class="level-item button is-primary"
          >
            <span class="icon is-small"><i class="fa fa-save"></i></span>
            <span>{{ $t('save') }}</span>
          </button>
        </div>
      </nav>
    </form>
  </div>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'
import { Campus } from '@/models/core'

export default {
  name: 'Campus',
  components: {
    'serveur-info': () => import('@/components/ServeurInfo.vue'),
    'entity-form': () => import('@/components/admin/entity/EntityForm.vue'),
    'my-notification': () => import('@/components/MyNotification.vue'),
    'domain-input': () => import('@/components/core/DomainInput.vue'),
    'type-input': () => import('@/components/core/InstitutionTypeInput.vue')
  },
  props: {
    loaded: {
      type: Boolean,
      required: false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      error: '',
      hasChanged: false,
      campus: Campus.createEmpty()
    }
  },
  setup () {
    const adminStore = useAdminStore()
    return { adminStore }
  },
  computed: {
    savedCampus: function () {
      return this.adminStore.entity
    },
    ICON: function () {
      return Campus.ICON
    },
    resetDisabled: function () {
      let toReturn = true
      if (this.campus.id !== null) {
        toReturn = !this.hasChanged
      } else {
        toReturn = true
      }
      return toReturn
    },
    saveDisabled: function () {
      return false
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const loadingComponent = this.$buefy.loading.open({
            container: null
          })
          this.adminStore
            .saveEntity(Campus.createFromObj(this.campus))
            .then((data) => {
              loadingComponent.close()
              window.scrollTo(0, 0)
              this.$buefy.toast.open({
                type: 'is-light',
                message: this.$t('compAdminEntityCampus.save-msg')
              })
            })
            .catch((error) => {
              this.initCampus()
              loadingComponent.close()
              this.error = error.response.data
            })
        }
      })
    },
    initCampus () {
      this.hasChanged = false
      this.error = ''
      this.campus = Campus.createFromObj(Object.assign({}, this.savedCampus))
    },
    inputChanged () {
      this.hasChanged = true
    }
  },
  watch: {
    loaded: function () {
      this.initCampus()
    }
  },
  mounted () {
    this.initCampus()
  }
}
</script>
